import { FormattedMessage } from "react-intl";
import { default as BaseEmptyState } from "src/components/EmptyState";
import { EmptyStateStyled } from "./styles";

interface EmptyStateProps {
  status: "error" | "no-results";
}

export const EmptyState = (props: EmptyStateProps): JSX.Element => {
  const titleMessage =
    props.status === "error"
      ? {
          id: "admin.log.load_error",
          defaultMessage: "Failed to load activity log",
        }
      : {
          id: "admin.log.no_activity",
          defaultMessage: "No activity found",
        };
  const descriptionMessage =
    props.status === "error"
      ? {
          id: "admin.log.load_error_description",
          defaultMessage:
            "There was a problem loading the audit log. Please try again later.",
        }
      : {
          id: "admin.log.no_activity_description",
          defaultMessage:
            "No activity recorded in the audit log. Please adjust your filters or check back later.",
        };

  return (
    <EmptyStateStyled>
      <BaseEmptyState section="search-logs">
        <h3>
          <FormattedMessage {...titleMessage} />
        </h3>
        <p>
          <FormattedMessage {...descriptionMessage} />
        </p>
      </BaseEmptyState>
    </EmptyStateStyled>
  );
};
